"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@eig-builder/core-ui/styles");

var _compositionsResponsiveTabs = _interopRequireDefault(require("@eig-builder/compositions-responsive-tabs"));

var _modalContext = _interopRequireDefault(require("./modal-context"));

// Core UI
// Context
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      zIndex: 10,
      position: 'fixed',
      minHeight: '48px',
      top: function top(props) {
        return props.offset;
      },
      left: '0',
      width: '100%',
      padding: theme.spacing(0, 6),
      background: theme.palette.lightGray.main,
      borderBottom: "1px solid ".concat(theme.palette.black.lighter),
      '& > div': {
        borderBottom: 'none'
      },
      '&.modal-tabs-transparent': {
        background: 'transparent'
      },
      '&.modal-tabs-light': {
        background: theme.palette.white.main
      }
    }
  };
});

var ModalTabs = function ModalTabs(_ref) {
  var value = _ref.value,
      tabs = _ref.tabs,
      mobileRes = _ref.mobileRes,
      fullWidth = _ref.fullWidth,
      onChange = _ref.onChange,
      dataElementPrefix = _ref.dataElementPrefix,
      dataElementLocation = _ref.dataElementLocation;

  var _useContext = (0, _react.useContext)(_modalContext["default"]),
      variant = _useContext.variant,
      headerRef = _useContext.headerRef,
      tabsRef = _useContext.tabsRef;

  var _useState = (0, _react.useState)(64),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      offset = _useState2[0],
      setOffset = _useState2[1];

  (0, _react.useEffect)(function () {
    if (headerRef.current && headerRef.current.clientHeight !== offset) {
      setOffset(headerRef.current.clientHeight);
    }
  }, [headerRef.current]);
  var classes = useStyles({
    offset: offset
  });
  return _react["default"].createElement("div", {
    ref: tabsRef
  }, _react["default"].createElement(_compositionsResponsiveTabs["default"], {
    classname: "modal-tabs modal-tabs-".concat(variant),
    modalclasses: classes,
    value: value,
    variant: "primary",
    mobileRes: mobileRes,
    ariaLabel: "modal tabs",
    dataElementPrefix: dataElementPrefix,
    dataElementLocation: dataElementLocation,
    tabs: tabs,
    handleChange: onChange,
    fullWidth: fullWidth
  }));
};

ModalTabs.propTypes = {
  tabs: _propTypes["default"].array.isRequired,
  dataElementPrefix: _propTypes["default"].string,
  dataElementLocation: _propTypes["default"].string,
  value: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  mobileRes: _propTypes["default"].number,
  fullWidth: _propTypes["default"].bool
};
ModalTabs.defaultProps = {
  fullWidth: false
};
var _default = ModalTabs;
exports["default"] = _default;